import { render, staticRenderFns } from "./workOrderRequestDetail.vue?vue&type=template&id=2a8a7f6a"
import script from "./workOrderRequestDetail.vue?vue&type=script&lang=js"
export * from "./workOrderRequestDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a8a7f6a')) {
      api.createRecord('2a8a7f6a', component.options)
    } else {
      api.reload('2a8a7f6a', component.options)
    }
    module.hot.accept("./workOrderRequestDetail.vue?vue&type=template&id=2a8a7f6a", function () {
      api.rerender('2a8a7f6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wod/workOrderRequestDetail.vue"
export default component.exports